import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ContractProvider } from './contexts/ContractContext';
import { DeveloperProvider } from './contexts/DeveloperContext';
import PrivateRoute from './components/PrivateRoute';
import AdminLayout from './components/admin/AdminLayout';
import Home from './components/Home';
import Formulario from './components/Formulario';
import AdminLogin from './components/admin/AdminLogin';
import DashboardNew from './components/admin/DashboardNew';
import ImportContracts from './components/admin/ImportContracts';
import Calendario from './components/admin/Calendario';
import Employees from './components/admin/Employees';

import Lembretes from './components/admin/Lembretes';
import ContractView from './components/admin/ContractView';
import { EmployeeDetails } from './components/admin/EmployeeDetails';
import EditContract from './components/admin/EditContract';
import CreateBudget from './components/admin/CreateBudget';
import ContractFlowPage from './components/admin/ContractFlowPage';
import MessageTemplates from './components/admin/MessageTemplates';
import EditMessageTemplate from './components/admin/EditMessageTemplate';
import TelegramTestPage from './components/admin/TelegramTestPage';
import WhatsAppConnectionPage from './components/admin/WhatsAppConnectionPage';
import BudgetInsights from './components/admin/BudgetInsights';
import Personagens from './components/admin/Personagens';
import MaintenanceSettings from './components/admin/MaintenanceSettings';
import { CredentialsPage } from './components/admin/CredentialsPage';
import { SystemLogs } from './components/admin/SystemLogs';
import { AdvancedSettings } from './components/admin/AdvancedSettings';
import { SystemMonitoring } from './components/admin/SystemMonitoring';
import { DeveloperRoute } from './components/admin/DeveloperRoute';
import MaintenancePage from './components/MaintenancePage';
import MaintenanceGuard from './components/MaintenanceGuard';
import MaintenanceRedirectWrapper from './components/MaintenanceRedirectWrapper';
import MaintenanceRedirectHandler from './components/MaintenanceRedirectHandler';
import ContractPDFDownload from './components/ContractPDFDownload';

import ContractTemplateEditor from './components/admin/ContractTemplateEditor';

function App() {
  return (
    <AuthProvider>
      <ContractProvider>
        <DeveloperProvider>
          <MaintenanceRedirectWrapper>
            <Router>
              <div className="App">
                <MaintenanceRedirectHandler />
                <Routes>
                  {/* Public Routes */}
                  <Route path="/" element={<MaintenanceGuard><Home /></MaintenanceGuard>} />
                  <Route path="/formulario" element={<MaintenanceGuard><Formulario /></MaintenanceGuard>} />
                  <Route path="/contrato/:id/pdf" element={<ContractPDFDownload />} />
                  <Route path="/admin/login" element={<AdminLogin />} />
                  <Route path="/manutencao" element={<MaintenancePage />} />

                  {/* Protected Admin Routes */}
                  <Route path="/admin" element={
                    <PrivateRoute>
                      <MaintenanceGuard>
                        <AdminLayout />
                      </MaintenanceGuard>
                    </PrivateRoute>
                  }>
                    <Route index element={<Navigate to="/admin/contratos" replace />} />
                    <Route path="contratos" element={<DashboardNew />} />
                    <Route path="contratos/:id" element={<ContractView />} />
                    <Route path="contratos/editar/:id" element={<EditContract />} />
                    <Route path="contratos/orcamento/:id" element={<CreateBudget />} />
                    <Route path="contratos/fluxo/:id" element={<ContractFlowPage />} />
                    <Route path="importar" element={<ImportContracts />} />
                    <Route path="calendario" element={<Calendario />} />
                    <Route path="funcionarios" element={<Employees />} />
                    <Route path="funcionarios/:id" element={<EmployeeDetails />} />

                    <Route path="lembretes" element={<Lembretes />} />
                    <Route path="mensagens" element={<MessageTemplates />} />
                    <Route path="mensagens/criar" element={<EditMessageTemplate />} />
                    <Route path="mensagens/editar/:id" element={<EditMessageTemplate />} />
                    <Route path="teste-telegram" element={<TelegramTestPage />} />
                    <Route path="whatsapp" element={<WhatsAppConnectionPage />} />
                    <Route path="estudo-orcamentos" element={<BudgetInsights />} />
                    <Route path="personagens" element={<Personagens />} />
                    <Route path="modelo-contrato" element={<ContractTemplateEditor />} />
                    <Route path="credenciais" element={
                      <DeveloperRoute>
                        <CredentialsPage />
                      </DeveloperRoute>
                    } />
                    <Route path="logs" element={
                      <DeveloperRoute>
                        <SystemLogs />
                      </DeveloperRoute>
                    } />
                    <Route path="configuracoes" element={
                      <DeveloperRoute>
                        <AdvancedSettings />
                      </DeveloperRoute>
                    } />
                    <Route path="monitoramento" element={
                      <DeveloperRoute>
                        <SystemMonitoring />
                      </DeveloperRoute>
                    } />
                    <Route path="configuracoes-manutencao" element={
                      <MaintenanceSettings />
                    } />
                  </Route>

                  {/* Legacy Routes - Redirect to new admin */}
                  <Route path="/dashboard" element={<Navigate to="/admin/contratos" replace />} />
                  <Route path="/gerenciamento" element={<Navigate to="/admin/contratos" replace />} />
                  <Route path="/import" element={<Navigate to="/admin/importar" replace />} />
                  <Route path="/employees" element={<Navigate to="/admin/funcionarios" replace />} />


                  {/* Catch all - redirect to home */}
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </div>
            </Router>
          </MaintenanceRedirectWrapper>
        </DeveloperProvider>
      </ContractProvider>
    </AuthProvider>
  );
}

export default App;
